module.exports = __webpack_public_path__ + "img/device-activated.2e0bf7f9.svg";